module.exports = __webpack_public_path__ + "img/volume-1.e28b2925.svg";